(function() {
    'use strict';

    angular
        .module('jotApp')
        .controller('TabPropertiesDeleteController',TabPropertiesDeleteController);

    TabPropertiesDeleteController.$inject = ['$uibModalInstance', 'entity', 'TabProperties'];

    function TabPropertiesDeleteController($uibModalInstance, entity, TabProperties) {
        var vm = this;
        vm.tabProperties = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            TabProperties.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
